import clsx from 'clsx';
import {ChevronUp} from 'lucide-react';

export function CollapseChevron({className, open}: {className?: string; open: boolean}) {
  return (
    <ChevronUp
      className={clsx('h-5 w-5 transition-transform', !open ? 'rotate-180' : '', className)}
    />
  );
}
